/** @jsxImportSource @emotion/react */
import React from 'react';
import { DatePicker, Form, Input, Space, Typography } from 'antd';
import commonStyles from '../../../../../styles/commonStyles';
import { formStyles } from '../constants';
import type { LockedLocationInfo } from '../types';

interface LockedLocationSectionProps {
  info: LockedLocationInfo;
}

/**
 * Read-only location display for the "bed page" scenario
 * where location is pre-determined and cannot be changed.
 */
const LockedLocationSection: React.FC<LockedLocationSectionProps> = ({ info }) => (
  <>
    <Typography.Title level={5} css={formStyles.sectionTitle}>
      Параметры размещения
    </Typography.Title>

    <Space direction="vertical" size={8} css={commonStyles.fullWidth}>
      <Typography.Text>Поле: {info.fieldLabel}</Typography.Text>
      <Typography.Text>Участок: {info.plotLabel}</Typography.Text>
      <Typography.Text>Грядка: {info.bedLabel}</Typography.Text>
      <Typography.Text type="secondary">
        Локация выбрана автоматически и недоступна для изменения.
      </Typography.Text>

      {/* Hidden fields keep location values in form state */}
      <Form.Item name={['locations', 0, 'id']} hidden>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name={['locations', 0, 'fieldId']} hidden>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name={['locations', 0, 'plotId']} hidden>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name={['locations', 0, 'bedId']} hidden>
        <Input type="hidden" />
      </Form.Item>

      <Space direction="horizontal" css={formStyles.fullWidthSpace}>
        <Form.Item
          label="Дата начала"
          name={['locations', 0, 'fromDate']}
          rules={[{ required: true, message: 'Укажите дату начала' }]}
          css={formStyles.flexOne}
        >
          <DatePicker format="YYYY-MM-DD" css={commonStyles.fullWidth} />
        </Form.Item>
        <Form.Item
          label="Дата окончания"
          name={['locations', 0, 'toDate']}
          css={formStyles.flexOne}
        >
          <DatePicker format="YYYY-MM-DD" css={commonStyles.fullWidth} allowClear />
        </Form.Item>
      </Space>
    </Space>
  </>
);

export default LockedLocationSection;
